import { ContentContext } from "../../../../../utils/contexts";

const moment = window.moment;
const {
  Link,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Divider,
  withStyles,
  Chip,
  Button,
} = window.Material;
const { Star, StarBorder, Chat, Gavel, PlaylistAddCheck, FileCopy } = window.MaterialIcons;
import { FILTERED_INDICATORS } from "../../../../../constants";
import { savePreferences } from "../../../../../actions";

const styles = {
  avatar: {
    fontSize: '22px',
    minWidth: 'auto',
    marginRight: '10px',
    color: '#e3c305',
    '& .blue': {
      color: '#0e1f3e',
    },
  },
  divider: {
    margin: '0 !important',
  },
  item: {
    paddingLeft: '16px !important',
    paddingTop: '0',
    paddingBottom: '0',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  tags: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: '5px',
      margin: '0 5px 0 0',
    },
  },
  link: {
    fontSize: '13px',
    '&:hover': {
      color: '#0c79bf !important',
    },
  },
  text: {
    fontSize: '13px',
    maxWidth: '50%',
    wordBreak: 'break-all',
  },
  chipLabel: {
    paddingRight: '3px',
    paddingLeft: '3px',
  },
  favourite: {
    color: '#ff9a00',
  },
  copyBtn: {
    borderRadius: '16px',
  },
  label: {
    fontSize: '13px',
  }
};

class Folder extends React.PureComponent {

  onClickSelect = () => {
    const { item } = this.props;
    const { onItemSelect } = this.context;

    onItemSelect(item);
  };

  onClickGoIn = async event => {
    event.preventDefault();

    const {
      item: { nodeRef },
      treeItems,
    } = this.props;

    const { fetchContent, fetchTreeChildren, breadcrumbs, fetchBreadcrumbs } = this.context;

    const isCurrent = nodeRef === breadcrumbs[breadcrumbs.length - 1]?.nodeRef;

    if (isCurrent) {
      this.setState(state => ({ open: !state.open }));
    } else {
      await fetchContent(nodeRef, 1);
      fetchBreadcrumbs(nodeRef);

      // if (!Boolean(treeItems[nodeRef])) {
      //   await fetchTreeChildren(nodeRef);
      // }

      this.setState(() => ({ open: true }));
    }
  };

  addToFavourites = async () => {
    const { item: { nodeRef } } = this.props;
    const { favouriteFolders, fetchPreferences } = this.context;

    const newFavourites = {
      ...favouriteFolders,
      [nodeRef]: nodeRef,
    };

    await savePreferences({
      org: { alfresco: { share: { folders: { favourites: Object.keys(newFavourites).join(',') } } } },
    });

    fetchPreferences();
  };

  removeFromFavourites = async () => {
    const { item: { nodeRef } } = this.props;
    const { favouriteFolders, fetchPreferences } = this.context;

    const newFavourites = {
      ...favouriteFolders,
    };

    delete newFavourites[nodeRef];

    await savePreferences({
      org: { alfresco: { share: { folders: { favourites: Object.keys(newFavourites).join(',') } } } },
    });

    fetchPreferences();
  };

  onCopyLink = niceURL => {
    const root = document.getElementById("path-picker-body");

    if (root) {
      const link = `${window.location.origin}/share/page/browse/${niceURL}`;

      const textArea = document.createElement('textarea');

      textArea.value = link;
      textArea.textContent = link;

      root.appendChild(textArea);

      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.log(err);
      }

      root.removeChild(textArea);
    }
  };

  render() {
    const {
      item: { nodeRef, properties, name, indicators, disabled },
      classes,
      index,
    } = this.props;

    const { selected, hidden, loadingContent, favouriteFolders } = this.context;

    const isSelected = Boolean(selected[nodeRef]);
    const isHidden = Boolean(hidden[nodeRef]);
    const isInFavourites = favouriteFolders[nodeRef];

    const niceURL = properties['niceURL:niceURL'];

    const currentDay = moment();
    const modifiedDate = moment(properties['cm:modified'].iso8601);
    const hourDifference = currentDay.diff(modifiedDate, 'seconds') / 60 / 60;
    let time = '';
    const isOneDay = hourDifference > 24 && hourDifference < 47;

    if (hourDifference > 24) {
      //Days
      if (isOneDay) {
        //Day
        time = window.Alfresco.messages.global['relative.day'];
      } else {
        // more than 1 day
        time = Math.round(hourDifference / 24) + ` ${window.Alfresco.messages.global['date-unit.plural.day']}`;
      }
    } else {
      if (hourDifference > 1) {
        //Hours
        time = Math.round(hourDifference) + ` ${window.Alfresco.messages.global['date-unit.plural.hour']}`;
      } else {
        //Minutes
        time = Math.round(hourDifference * 60) + ` ${window.Alfresco.messages.global['date-unit.plural.minute']}`;
      }
    }

    const hasMetafill = indicators.find(indicator => indicator.id === 'metafill');
    const hasRules = indicators.find(indicator => indicator.id === 'rules');

    return (
      <React.Fragment>
        <ListItem
          button
          disableRipple
          disableTouchRipple
          onClick={this.onClickSelect}
          selected={isSelected}
          disabled={disabled || isHidden || loadingContent}
          classes={{ root: classes.item }}
          id={`docLibItem${index}`}
        >
          <ListItemAvatar className={classes.avatar}>
            <i className={`fas fa-${isSelected ? 'check-circle blue' : 'folder'}`} />
          </ListItemAvatar>
          <ListItemText
            classes={{ primary: classes.text, secondary: classes.text }}
            primary={
              <Link href="#" classes={{ root: classes.link }} onClick={this.onClickGoIn}>
                {`${name}${window.Edocat?.Config?.showTitle && properties['cm:title'] ? ` (${properties['cm:title']})` : ''}`}
              </Link>
            }
            secondary={`${
              window.Alfresco.messages.global[
                `${isOneDay ? 'prop.cm_modified.title' : 'edocat.document-library.edited'}`
                ]
            } ${time} ${properties['cm:modifier'].displayName}`}
          />
          <ListItemSecondaryAction classes={{ root: classes.actions }}>
            {niceURL && (
              <Tooltip title={window.Alfresco.messages.global['edocat.document-actions.copy-link-folder']}>
                <Button
                  variant="contained"
                  disableElevation
                  endIcon={<FileCopy fontSize="small" />}
                  classes={{ root: classes.copyBtn, label: classes.label }}
                  onClick={() => this.onCopyLink(niceURL)}
                  id={`docLibItem${index}CopyLinkBtn`}
                  disabled={loadingContent}
                >
                  {niceURL}
                </Button>
              </Tooltip>
            )}
            {properties['cm:taggable'] && (
              <div className={classes.tags}>
                {properties['cm:taggable'].map(tag => (
                  <Chip key={tag.name} label={tag.name} />
                ))}
              </div>
            )}
            {/*indicators.length > 0 &&
              indicators
                .filter(indicator => !FILTERED_INDICATORS.includes(indicator.id))
                .map(indicator => (
                  <Tooltip
                    title={window.Alfresco.messages.global[indicator.label] || indicator.label}
                    key={indicator.id}
                  >
                    <span
                      className="hasIndicator"
                      style={{
                        backgroundImage: `url(${window.appContext}/res/components/documentlibrary/indicators/${indicator.icon})`,
                      }}
                    />
                  </Tooltip>
                ))*/}
            {Boolean(parseInt(properties['fm:commentCount'])) && (
              <div className={classes.tags}>
                <Chip>
                  <Chat fontSize="small" />
                  {properties['fm:commentCount']}
                </Chip>
              </div>
            )}
            {hasMetafill && (
              <div className={classes.tags}>
                <Tooltip title={window.Alfresco.messages.global['edocat.document-library.indicator.metafill']}>
                  <Chip label={<PlaylistAddCheck fontSize="small" />} classes={{ label: classes.chipLabel }} />
                </Tooltip>
              </div>
            )}
            {hasRules && (
              <div className={classes.tags}>
                <Tooltip title={window.Alfresco.messages.global['edocat.document-library.indicator.rules']}>
                  <Chip label={<Gavel fontSize="small" />} classes={{ label: classes.chipLabel }} />
                </Tooltip>
              </div>
            )}
            <Tooltip
              title={
                isInFavourites
                  ? window.Alfresco.messages.global['favourite.folder.remove.tip']
                  : window.Alfresco.messages.global['favourite.folder.add.tip']
              }
            >
              <IconButton
                onClick={isInFavourites ? this.removeFromFavourites : this.addToFavourites}
                id={`docLibItem${index}FavouriteBtn`}
                disabled={loadingContent}
              >
                {isInFavourites ? <Star classes={{ root: classes.favourite }} fontSize="small" /> : <StarBorder fontSize="small" />}
              </IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </ListItem>
        <Divider classes={{ root: classes.divider }} />
      </React.Fragment>
    );
  }
}

Folder.contextType = ContentContext;

export default withStyles(styles)(Folder);
